import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import LaunchIcon from '@mui/icons-material/Launch';
import { Link } from '@mui/material';
import { NavBtn } from 'components';
import { useTranslation } from 'react-i18next';
import { ProductFieldType } from 'types';

const isHyperLink = (linkString: string) => {
	let reg =
		/^((ht|f)tps?):\/\/([\w\-]+(\.[\w\-]+)*\/)*[\w\-]+(\.[\w\-]+)*\/?(\?([\w\-\.,@?^=%&:\/~\+#]*)+)?/;

	return reg.test(linkString);
};

const ProductFieldValue = (productField: ProductFieldType) => {
	const { t, i18n } = useTranslation();
	const valueType = productField.valueType;
	const fieldType = productField.fieldType;
	let value;

	if (valueType === 1) {
		//	Text
		if (fieldType === 1) {
			//different languages has different content
			value = productField.value
				? productField.value[i18n.resolvedLanguage]
					? productField.value[i18n.resolvedLanguage]
					: productField.value[process.env.REACT_APP_DEFAULT_LANG!]
				: null;
		} else if (fieldType === 2) {
			//different languages share the same value
			value = productField.value;
		}
	} else if (valueType === 2) {
		//	Date
		value = productField.value;
	} else if (valueType === 3) {
		//the value is object
		value = `${process.env.REACT_APP_DOMAIN_NAME}${process.env.REACT_APP_API_GET_VIDEO}?name=${productField.value}`;
	}

	if (productField.code === 'owner') {
		return (
			<span
				style={{
					display: 'flex',
					flexDirection: 'row',
					alignItems: 'flex-end',
					justifyContent: 'space-between',
				}}
			>
				<span>{value}</span>
				<span>
					<NavBtn to={'/ownershipTimeline'}>
						<ArrowForwardIosIcon />
					</NavBtn>
				</span>
			</span>
		);
	}

	if (isHyperLink(value) || valueType === 3) {
		return (
			<Link
				href={value}
				sx={{
					alignItems: 'center',
					display: 'flex',
				}}
				target="_blank"
			>
				{valueType === 3 ? (
					t('product.playVideo')
				) : (
					<>
						{t('product.clickJump')}{' '}
						<LaunchIcon
							sx={{
								paddingLeft: '10px',
							}}
						/>
					</>
				)}
			</Link>
		);
	}

	return <span>{value}</span>;
};

export default ProductFieldValue;
